


import React, { createContext, useContext, useEffect, useState } from "react";
import {
  List,
  Button,
  Typography,
  Tooltip,
  message,
  notification,
  Badge,
  Popconfirm,
  Skeleton,
  Select,
  Form,
  Radio
} from "antd";

import "../../style/commercialobligationsettings.css";
import { Dialog, DialogFooter } from "@fluentui/react/lib/Dialog";
import { TextField } from "@fluentui/react/lib/TextField";
import {
  PrimaryButton,
  DefaultButton,
} from "@fluentui/react/lib/Button";
import * as yup from "yup";
import { observer } from "mobx-react";
import { Formik } from "formik";
import { Scrollbars } from "react-custom-scrollbars";

import { Spinner, SpinnerSize } from "@fluentui/react";

import { MessageBar, MessageBarType } from "@fluentui/react";
import WrfmSettingStore from "../../store/wrfmsettingstore";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { getCurrentUser } from "../../../../Utility/modules/helpers";
import { HelpCircle } from "react-feather";
const { Title } = Typography;


const wrfmStoreCtx = createContext(WrfmSettingStore);
export const Levels = observer((props) => {
    const [levelStatus, setStatus] = useState("Active");
  const wrfmStore = useContext(wrfmStoreCtx);
  
  const permissionStore = {};
  const [state, setState] = useState({
    hideDialog: true,
    action: "add",
    selRow: {},
  });

  useEffect(() => {
    async function loadLevels() {
      try {
        await wrfmStore.loadLevels();
      } catch (error) {
        notification.error({
          message: "Feedback Manager",

          description: `Something went wrong.${error.message}.`,
        });
      }
    }
    loadLevels();
  }, []);

  const _closeDialog = () => {
    setState({ hideDialog: true });
  };
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const level = { ...values, uploadedBy: getCurrentUser().fullName };

      console.log(level);
      const retVal = await wrfmStore.createLevel(level);
      wrfmStore.levels.set(retVal.levelId, retVal);
if(state.action==='edit'){
  message.success(`${level.levelName} level modified successfully`);
}else{
  message.success(`${level.levelName} level created successfully`);
}
    
        setSubmitting(false);
      setState({ hideDialog: true }); 
    } catch (error) {
      
      notification.open({
        message: "Feedback Manager",
        type: "error",

        description: `${error.response.text}.`,
      });
      setSubmitting(false);
    }
  };
  return (
    <div
      className="ms-Grid"
      dir="ltr"
      style={{ borderRight: "1px solid #F0F2F5", marginRight: "5px" }}
    >
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          {" "}
          <Scrollbars style={{ height: "100vh", overflowX: "hidden" }}>
            {wrfmStore.isLoading ? (
              <>
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
              </>
            ) : (
              <List
                itemLayout="horizontal"
                dataSource={[...wrfmStore.levels.values()]}
                size="small"
                style={{ width: "95%" }}
                header={
                  <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm10">
                        {" "}
                        <Title
                          level={4}
                          style={{
                            display: "inline-block",
                            marginRight: "5px",
                            fontSize: "16px",
                            color: "red",
                          }}
                        >
                          Levels 
                        </Title>
                        <Badge count={wrfmStore.levels.size}  overflowCount={300}/>
                      </div>
                      <div
                        className="ms-Grid-col ms-sm2"
                        style={{
                          textAlign: "right",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Tooltip title="Add  New Level">
                          <Button
                            shape="circle"
                            icon={<PlusOutlined />}
                            type="primary"
                            onClick={(ev) => {
                              setState({
                                hideDialog: false,
                                action: "add",
                                header: `Create New  Level`,
                                selRow: {},
                              });
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                    <div className="ms-Grid-row" style={{ paddingTop: "10px" }}>
                      <div className="ms-Grid-col ms-sm12">
                        <MessageBar messageBarType={MessageBarType.warning}>
                          click  edit or delete  to modify level name,status or remove level
                        </MessageBar>
                      </div>
                    </div>
                  </div>
                }
                renderItem={(item) => (
                  <List.Item
                    actions={[
                      <Tooltip
                        title={`modify ${item?.levelName} level`}
                      >
                        <Button
                          type="link"
                          icon={<EditOutlined />}
                         
                          style={{ fontSize: "18px" }}
                          onClick={() => {
                            setState({
                              action: `edit`,
                              header: `Change ${item?.levelName.toUpperCase()} level attribute`,
                              hideDialog: false,
                              selRow: item,
                            });
                            setStatus(item?.levelStatus)
                          }}
                        />
                      </Tooltip>,
                      <Tooltip
                        title={`Delete ${item?.levelName.toUpperCase()} level`}
                      >
                        <Popconfirm
                          title={`Are you sure you want to remove ${item?.levelName} level ？`}
                          okText="Yes"
                          cancelText="No"
                          onConfirm={() => {
                            try {
                              permissionStore.removePriviledge(item);
                              message.success(
                                `${item.name} level removal was successfull`
                              );
                            } catch (error) {
                              message.error(
                                `something went wrong  due to : ${error.message} `
                              );
                            }
                          }}
                        >
                          <Button
                            type="link"
                            disabled
                            icon={<DeleteOutlined />}
                            style={{ fontSize: "18px" }}
                          />
                        </Popconfirm>
                      </Tooltip>,
                      <Tooltip
                        title={
                          <div className="ms-Grid" dir="ltr">
                            {" "}
                            <div className="ms-Grid-row">
                              <div className="ms-Grid-col ms-sm12">audit</div>
                            </div>
                            <div className="ms-Grid-row">
                              <div className="ms-Grid-col ms-4">created by</div>{" "}
                              <div className="ms-Grid-col ms-8">
                                {item?.uploadedBy}
                              </div>
                            </div>
                            <div className="ms-Grid-row">
                              <div className="ms-Grid-col ms-sm12">
                                {item?.uploadedOn}
                              </div>
                            </div>
                          </div>
                        }
                      >
                        <Button type="link" icon={<HelpCircle />} size={16} />
                      </Tooltip>,
                    ]}
                  >
                    <List.Item.Meta
                      title={<span>{item.levelName}</span>}
                      
                    />
                  </List.Item>
                )}
              />
            )}
          </Scrollbars>
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <Dialog
            hidden={state.hideDialog}
            onDismiss={_closeDialog}
            dialogContentProps={{
              title: state.header,
              subText: "Enter name  for the level.",
            }}
            modalProps={{
              isBlocking: false,
              styles: { main: { maxWidth: 450 } },
              dragOptions: true,
            }}
          >
            <Formik
              initialValues={state.selRow}
              onSubmit={(values, { setSubmitting }) => {
                handleSubmit(values, { setSubmitting });
              }}
              validationSchema={yup.object().shape({
                levelName: yup
                  .string()
                  .required("level Name is required"),
               
              })}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => {
                return (
                  <Form onFinish={handleSubmit} layout="vertical">
                    <div className="ms-Grid" dir="ltr">
                      <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12">
                          <TextField
                            label="Level Name "
                            required
                            name="levelName"
                            value={values?.levelName}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            errorMessage={
                              touched.levelName && errors.levelName
                            }
                          />
                        </div>
                      </div>{" "}
                     
                      <div
                        className="ms-Grid-row"
                        style={{ marginTop: "10px" }}
                      >
                        <div className="ms-Grid-col ms-sm12">
                          {isSubmitting && (
                            <Spinner
                              label="saving level record,please wait..."
                              ariaLive="assertive"
                              labelPosition="right"
                              size={SpinnerSize.large}
                            />
                          )}
                        </div>
                      </div>
                      <DialogFooter>
                        <PrimaryButton text="Save" type="submit" />
                        <DefaultButton onClick={_closeDialog} text="Cancel" />
                      </DialogFooter>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </Dialog>
        </div>
      </div>
    </div>
  );
});

